import React, { useEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useRouter, Stack } from 'expo-router';
import { Ionicons } from '@expo/vector-icons';
import Button from '../../src/components/Button';
import { useAuth } from '../../src/context/AuthContext';
import { useTheme } from '../../src/context/ThemeContext';
import { spacing, fontSize, fontWeight } from '../../src/utils/theme';
import ContentContainer from '../../src/components/ContentContainer';
import type { ColorTheme } from '../../src/utils/theme';

/** PaymentCompleteScreen - success confirmation after a wash payment completes. */
export default function PaymentCompleteScreen() {
  const { colors } = useTheme();
  const styles = useStyles(colors);
  const router = useRouter();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) router.replace('/');
  }, [isLoading, isAuthenticated]);

  return (
    <>
      <Stack.Screen options={{ title: 'Payment Complete' }} />
      <View style={styles.container}>
        <ContentContainer maxWidth={480}>
          <Ionicons name="checkmark-circle" size={80} color={colors.success} />
          <Text style={styles.title}>Payment Successful!</Text>
          <Text style={styles.subtitle}>Your wash has been activated.</Text>
          <Button
            title="Back to Home"
            onPress={() => router.replace('/')}
            style={styles.btn}
          />
        </ContentContainer>
      </View>
    </>
  );
}

const createStyles = (c: ColorTheme) => StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', alignItems: 'center', padding: spacing.xl, backgroundColor: c.background },
  title: { fontSize: fontSize.xxl, fontWeight: fontWeight.bold, color: c.text, marginTop: spacing.lg },
  subtitle: { fontSize: fontSize.md, color: c.textSecondary, marginTop: spacing.sm },
  btn: { marginTop: spacing.xl, minWidth: 200 },
});
const useStyles = (c: ColorTheme) => React.useMemo(() => createStyles(c), [c]);
